import { Box, Button, Typography } from "@mui/material";
import React from "react";
import UserList from "./components/UserList";
import { useNavigate } from "react-router";
import { useHasPolicy } from "@config/useHasPolicy";
import { PolicyEnum } from "@config/policyEnum";
const Users: React.FC = () => {
  const navigate = useNavigate();
  const showAddUser = useHasPolicy(PolicyEnum.VIEW_ADD_USER);
  const editAddUser = useHasPolicy(PolicyEnum.EDIT_ADD_USER);
  return (
      <Box className="px-4 md:px-8 pt-6" sx={{ height: "calc(100vh - 120px)" }}>
        <Box className="flex pb-4 justify-between ">
          <Box className="hidden md:flex items-center">
            <Typography className="pl-2">Users</Typography>
          </Box>
          {showAddUser &&
          <Box className="w-full md:w-fit">
            <Button
              style={{
                backgroundColor: "#318FE0",
                color: "#fff",
                textTransform: "none",
                padding: "10px 18px",
                fontSize: "1rem",
                width: "100%",
                fontWeight:500
              }}
              onClick={() => navigate(`/users/new`)}
              disabled={!editAddUser}
            >
              Add User
            </Button>
          </Box>}
        </Box>
        <UserList />
      </Box>
  );
};

export default Users;
